export default __webpack_public_path__ + "static/media/poster_print.faa7b0b6.jpg";